import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported as analyticsSupported } from 'firebase/analytics';
import { getRemoteConfig } from 'firebase/remote-config';
import { getDefaultAppConfig } from './assets/constants/defaultAppConfig';
const firebaseConfig = {
    apiKey: getDefaultAppConfig().REACT_APP_FIREBASE_API_KEY,
    authDomain: getDefaultAppConfig().REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: getDefaultAppConfig().REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: getDefaultAppConfig().REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: getDefaultAppConfig().REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: getDefaultAppConfig().REACT_APP_FIREBASE_APP_ID,
    measurementId: getDefaultAppConfig().REACT_APP_FIREBASE_MEASUREMENT_ID,
};
const app = initializeApp(firebaseConfig);
let analytics;
analyticsSupported().then((yes) => {
    if (yes) {
        analytics = getAnalytics(app);
    }
});
const remoteConfig = getRemoteConfig(app);
const parseEnvNumber = (value, fallback) => {
    const parsed = parseInt(value ?? '');
    return isNaN(parsed) ? fallback : parsed;
};
remoteConfig.settings = {
    minimumFetchIntervalMillis: parseEnvNumber(getDefaultAppConfig().REACT_APP_MIN_FETCH_INTERVAL_MILLIS, 1800000),
    fetchTimeoutMillis: parseEnvNumber(getDefaultAppConfig().REACT_APP_FETCH_TIMEOUT_MILLIS, 60000),
};
export { app, analytics, remoteConfig };
